// Masifi: solo es/en (decisión 2026-06-16). Ver config/initializers/masifi_languages.rb
// y docs/upgrade-runbook.md.
import en from './locale/en.json';
import es from './locale/es.json';

export default {
  en,
  es,
};
